import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HolidayDbService } from './holiday-db.service';
import { Holiday } from './holiday.models';

@Injectable({ providedIn: 'root' })
export class HolidayService {

  private holidayDbService = inject(HolidayDbService);

  getHolidaysByYear$(year: number): Observable<Holiday[]> {
    return this.holidayDbService.get$(year.toString()).pipe(
      map(holidayYear => holidayYear?.holidays ?? [])
    );
  }
}
